export default "__VITE_ASSET__BI17kR7v__"